module.exports = __webpack_public_path__ + "assets/img/wx.93a92546.png";